import { Edit, useForm } from "@refinedev/antd";
import { HttpError } from '@refinedev/core';
import { Form, Input, Button } from "antd";
import { useState } from "react";
import { IconDisplay } from "../../../components/IconDisplay";
import { ImageUpload } from "../../../components/ImageUpload";

export function OfferEdit() {
  const [showUpload, setShowUpload] = useState(false);

  const { formProps, saveButtonProps, query, formLoading } = useForm<any, HttpError, any>({
    resource: "offer",
    successNotification: (data) => {
      return {
        message: data?.data.message,
        type: "success",
      };
    },
    action: "edit",
  });

  const offer = query?.data?.data?.data;
  // console.log("Offer:", offer)

  return (
    <Edit
      saveButtonProps={saveButtonProps}
      isLoading={formLoading}
      resource="offer"
      mutationMode="optimistic"
      title="Edit Offer"
    >
      <Form 
        {...formProps} 
        layout="vertical"
      >
        <Form.Item
          label="Name"
          name={["name"]}
          initialValue={offer?.name}
          rules={[{ required: true }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Description"
          name={["description"]}
          initialValue={offer?.description}
          rules={[{ required: true }]}
        >
          <Input.TextArea />
        </Form.Item>

        <Form.Item
          label="Icon"
          name="iconID"
          initialValue={offer?.iconID}
        >
          {!showUpload ? (
            <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
              <IconDisplay iconURL={offer?.iconURL} />
              <Button onClick={() => setShowUpload(true)}>Change Icon</Button>
              <Button
                onClick={() => {
                  formProps.form?.setFieldsValue({ iconID: null });
                  setShowUpload(true);
                }}
                disabled={!offer?.iconID}
              >
                Remove Icon
              </Button>
            </div>
          ) : (
            <ImageUpload />
          )}
        </Form.Item>
      </Form>
    </Edit>
  );
}
